const TopLine = () => <div className="border-t-2 w-full" />;

export default TopLine;
